import React, { useState, useEffect } from "react";
import Content from "../components/Content";
import Button from "@mui/material/Button";
import LayoutLogin from "../containers/LayoutLogin";
import Card from "@mui/material/Card";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { CardContent } from "@mui/material";
import { useNavigate } from "react-router-dom";
import UsuariosService from "../services/UsuariosService";
import EmpleadosService from "../services/EmpleadosService";
import SucursalesService from "../services/SucursalesService";
import Swal from "sweetalert2";
import LockIcon from "@mui/icons-material/Lock";
import InputLabel from "@mui/material/InputLabel";

const Login = () => {

  useEffect(() => {
    document.title = "Inicio de sesión";
  }, []);
  function mostrarError(mensaje) {
    Swal.fire({
      title: "¡Error!",
      text: mensaje,
      icon: "error",
      confirmButtonText: "Aceptar",
    });
  }

  const [contrasenia, setContrasenia] = useState("");
  const [usuario, setUsuario] = useState("");
  const navigate = useNavigate();

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSubmit();
    }
  };

  const handleContrasenia = (event) => {
    setContrasenia(event.target.value);
  };

  const handleUsuario = (event) => {
    setUsuario(event.target.value);
  };

  const handleSubmit = async () => {
    try {
      const user = await UsuariosService.getLogin(usuario, contrasenia);
      if (user === undefined) {
        mostrarError("No se pudo conectar al servidor. Por favor, compruebe su conexión o intente más tarde.");
        return;
      }
      if (user[0] === undefined) {
        mostrarError("El usuario o la contraseña son incorrectos!");
      } else {
        if (user[0].rol === "E") {
          const empleado = await EmpleadosService.getEmpleadoByUser(
            user[0].idUsuario,
          );
          if (!empleado || empleado[0] === undefined) {
            mostrarError("No se encontró la información del empleado.");
            return;
          }
          const infoU = {
            id: user[0].idUsuario,
            nombre:
              user[0].nombre + " " + user[0].apPaterno + " " + user[0].apMaterno,
            sucursal: empleado[0].idSucursal,
            nombreSucursal: empleado[0].nombreSucursal,
            empleado: empleado[0].idEmpleado,
            usuario: user[0].usuario,
            rol: user[0].rol,
          };
          const usuarioString = JSON.stringify(infoU);
          sessionStorage.setItem("usuario", usuarioString);
        } else if (user[0].rol === "M") {
          mostrarError("El usuario o la contraseña son incorrectos!");
        } else {
          let idSucursalAdmin = user[0].idSucursal || 1;
          let nombreSucursalAdmin = user[0].nombreSucursal || "";

          const savedSuc = localStorage.getItem(`admin_sucursal_${user[0].idUsuario}`);
          if (savedSuc) {
            try {
              const parsedSuc = JSON.parse(savedSuc);
              if (parsedSuc && parsedSuc.idSucursal) {
                idSucursalAdmin = user[0].idSucursal || parsedSuc.idSucursal;
                if (!user[0].nombreSucursal && parsedSuc.nombreSucursal) {
                  nombreSucursalAdmin = parsedSuc.nombreSucursal;
                }
              }
            } catch (e) {}
          }

          if (!nombreSucursalAdmin) {
            try {
              const resSuc = await SucursalesService.getSucursales();
              const sucs = resSuc?.data?.sucursales || resSuc?.data || resSuc || [];
              const sucFound = sucs.find((s) => String(s.idSucursal || s.id) === String(idSucursalAdmin));
              if (sucFound) {
                nombreSucursalAdmin = sucFound.nombre || sucFound.nombreSucursal;
              }
            } catch (e) {}
          }

          if (!nombreSucursalAdmin) {
            nombreSucursalAdmin = "GUERRERO";
          }

          const infoU = {
            id: user[0].idUsuario,
            nombre:
              user[0].nombre + " " + user[0].apPaterno + " " + user[0].apMaterno,
            sucursal: Number(idSucursalAdmin),
            idSucursal: Number(idSucursalAdmin),
            nombreSucursal: nombreSucursalAdmin,
            usuario: user[0].usuario,
            rol: user[0].rol,
          };
          const usuarioString = JSON.stringify(infoU);
          sessionStorage.setItem("usuario", usuarioString);
          localStorage.setItem("usuario", usuarioString);
        }

        navigate("/menu", { state: { fromApp: true } });
      }
    } catch (error) {
      console.error(error);
      mostrarError("Hubo un error al comunicarse con el servidor. Por favor, intente más tarde.");
    }
  };
  return (
    <LayoutLogin>
      <Content>
        <Card
          variant="outlined"
          className="card"
          style={{
            backgroundColor: "#ffffff",
            borderColor: "#18234f",
            borderRadius: "16px",
            border: "1px solid rgba(255,255,255,0.3)",
          }}
        >
          <CardContent className="cardContLogin">
            <h2 className="LoginText">Inicio de sesión</h2>
            <InputLabel
              htmlFor="txfLogin"
              sx={{ color: "black", fontSize: 20, fontFamily: "Roboto-Medium" }}
            >
              Usuario
            </InputLabel>
            <TextField
              className="txfLogin"
              required
              sx={{
                "& .MuiInputLabel-root": { color: "black" },
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "white",
                  "& > fieldset": { borderColor: "black" },
                },
                "& .MuiOutlinedInput-root:hover": {
                  "& > fieldset": {
                    borderColor: "#A8AE17",
                  },
                },
                "& .MuiInputBase-input": {
                  color: "black",
                },
              }}
              id="outlined-required"
              onChange={handleUsuario}
              InputLabelProps={{ style: { color: "white" } }}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <AccountCircleIcon sx={{ color: "#18234f" }} />
                    </InputAdornment>
                  ),
                  sx: { bgcolor: "white" },
                  placeholder: "Ingrese su usuario",
                  style: { color: "white" },
                },
              }}
              variant="outlined"
            />
            <InputLabel
              htmlFor="txfLogin"
              sx={{ color: "black", fontSize: 20, fontFamily: "Roboto-Medium" }}
            >
              Contraseña
            </InputLabel>
            <TextField
              className="txfLogin"
              required
              sx={{
                "& .MuiInputLabel-root": { color: "white" },
                "& .MuiOutlinedInput-root": {
                  "& > fieldset": { borderColor: "black" },
                },
                "& .MuiOutlinedInput-root:hover": {
                  "& > fieldset": {
                    borderColor: "#A8AE17",
                  },
                },
              }}
              id="outlined-required"
              type="password"
              onChange={handleContrasenia}
              onKeyDown={handleKeyDown}
              InputLabelProps={{
                shrink: true,
                style: { color: "white" },
              }}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon sx={{ color: "#18234f" }} />
                    </InputAdornment>
                  ),
                  sx: { bgcolor: "white" },
                  placeholder: "Ingrese su contraseña",
                  style: { color: "black" },
                },
              }}
              style={{ borderColor: "#ffffff" }}
              variant="outlined"
            />
            <Button
              className="buttonLogin"
              variant="contained"
              sx={{
                backgroundColor: "#18234f",
                fontFamily: "Roboto-Medium",
                fontSize: 18,
                color: "white",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#384661",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                },
              }}
              onClick={handleSubmit}
            >
              Ingresar
            </Button>
          </CardContent>
        </Card>
      </Content>
    </LayoutLogin>
  );
};
export default Login;
